/**
 * Department operations for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class DeptManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async listDepts(name?: string): Promise<Record<string, any>> {
    const params: Record<string, any> = {};
    if (name) params.name = name;
    return this.session.get('/api/system/extend/dept', { params });
  }

  async getDept(deptId: number): Promise<Record<string, any>> {
    return this.session.get(`/api/system/dept/${deptId}`);
  }

  async listDeptTree(): Promise<Record<string, any>> {
    return this.session.get('/api/system/dept/tree');
  }
}
